/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-22 14:22:14
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-01-19 14:57:18
 */
import api from '@/api'
import {getOpenid} from '@/utils/auth'
import { Dialog } from 'vant';
import userData from './user'
const state = {
    details:{},
    goodsOrderList:[],//提交订单数据-到店取货
    orderDetail:{}
}
const mutations = {
    setAggPackDetail:(state, detail) => {
        state.details[detail.id] = detail
    },
    setGoodsOrderList:(state, detail) => {
        console.log(detail)
        state.goodsOrderList = detail
    },
    setOrderDetail:(state, detail) => {
        state.orderDetail = detail
    },
}
const actions = {
    getAggPack({commit,state},params){
        return new Promise((res,rej)=>{
            let detail = state.details[params.id]
            if(params.refresh||!detail){
                api.servicePack.getDetail(params).then(({data})=>{
                    res(data)
                    commit('setAggPackDetail',data)
                }).catch(err=>{
                    rej(err)
                })
            }else{
                res(detail)
            }
        })
    },
    // 确定收货
    confirmReceipt({commit,state},params){
        return new Promise((res,rej)=>{
            Dialog.alert({
                message: '是否确认签收',
                showCancelButton:true,
                cancelButtonText:'否',
                confirmButtonText:'是',
                confirmButtonColo:'#00BCD1'
            }).then(() => {
                api.order.confirmReceiptByServiceOrder(params).then((data)=>{
                    res(data)
                })
            });
        })
    },
    /**
     *
     * @param {*} tenantId  项目id
     * @param {*} id 总订单id
     */
    confirmPaymentByAgg({commit,state},{id,tenantId,isPayBehalf=0,callBackUrl}){
        return new Promise ((resolve,rej)=>{
            api.order.confirmPaymentByAgg({
                id,
                tenantId,
                isPayBehalf,
                nickname:userData.state.userInfo.name,
                openId:getOpenid(),
                callBackUrl
            }).then(({data})=>{
                if (data) {
                    window.location.href = data.webPayUrl;
                  //吊起支付
                //   api.pay.wxPay(data).then(res => {
                //      if (res.err_msg == "get_brand_wcpay_request:ok") {
                //         resolve(res)
                //      }
                //   });
                }
              })
        })
    },
    /**
     * 服务包订单详情
     */
    orderDetail({commit,state},params){
        return new Promise ((resolve,rej)=>{
            let detail = state.orderDetail
            if(params.refresh||!detail.id){
                api.servicePack.servicePackOrderInfo(params).then(({data})=>{
                    commit('setOrderDetail',data)
                    resolve(data)
                })
            }else{
                resolve(detail)
            }

        })
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
  }



// WEBPACK FOOTER //
// ./src/store/modules/aggPack.js